/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment } from "react";
import ListFooter from "./ListFooter";
import { useBooleanState } from "../../../../../../hooks/utils";
import {
  DataSourceId,
  NotificationId,
  SystemMappingNotification,
} from "../../../../../../globalTypes";
import MappingCardList from "./MappingCardList";
import TemplateCardList, { ExtendedTemplateMessage } from "./TemplateCardList";
import Loader from "../../../../../atoms/Loader";
import { useFormatMsg } from "../../../../../../hooks/useFormatMsg";
import { containerCss } from "./styles";
import { noop } from "../../../../../../globalConsts";
import SystemAdminCardList from "./SystemAdminCardList";

export type Props = {
  mappingMessages: SystemMappingNotification[];
  getMappingPageUrl: (id: DataSourceId) => string;

  templateMessages: ExtendedTemplateMessage[];

  dismissNotification: (id: NotificationId) => void;
  unexpandedVisibleCount: number;
  waitingForInitialLoad: boolean;

  onCardClickSideEffect: () => void;
};

const CardList: FC<Props> = ({
  mappingMessages,
  getMappingPageUrl,

  templateMessages,

  dismissNotification,
  unexpandedVisibleCount = 5,
  waitingForInitialLoad,

  onCardClickSideEffect = noop,
}) => {
  const [isExpanded, toggleIsExpanded] = useBooleanState(false);
  const formatMsg = useFormatMsg();

  const shouldCropMsgs =
    !isExpanded && templateMessages.length > unexpandedVisibleCount;

  const visibleTemplateMsgs = shouldCropMsgs
    ? templateMessages.slice(0, unexpandedVisibleCount)
    : templateMessages;

  const croppedMsgCount = templateMessages.length - unexpandedVisibleCount;

  return (
    <Fragment>
      <div css={containerCss} data-cy="card-list">
        <SystemAdminCardList
          onCardClickSideEffect={onCardClickSideEffect}
          dismissNotification={dismissNotification}
        />
        <MappingCardList
          messages={mappingMessages}
          dismissNotification={dismissNotification}
          getMappingPageUrl={getMappingPageUrl}
          onCardClick={onCardClickSideEffect}
        />

        {/* Hláška než se poprvé načtou data */}
        {waitingForInitialLoad && <Loader size={35} />}

        {/* Hláška když mám data, ale seznam je prázdný */}
        {!waitingForInitialLoad &&
          templateMessages.length === 0 &&
          formatMsg("notifications.template.empty")}

        <TemplateCardList
          dismissNotification={dismissNotification}
          messages={visibleTemplateMsgs}
          onCardClick={onCardClickSideEffect}
        />
      </div>
      <ListFooter
        toggleIsExpanded={toggleIsExpanded}
        isExpanded={isExpanded}
        croppedMsgCount={croppedMsgCount}
      />
    </Fragment>
  );
};

export default CardList;
export type CardListProps = Props;
